/** Reading order, and which catalogue rubrics each section gathers. */
export const GEAR_SECTIONS = [
    { id: "pa", rubrics: ["P.A."] },
    // УСИЛЕНИЕ — свой раздел, сразу за P.A. (владелец, 12.10.2026: «Все amplifiers лежат в
    // amplifications которые кроме бэклайна»). Своих рубрик из `KNOWN_GEAR_CATEGORIES` у него нет:
    // он наполняется по КАТАЛОГУ — любой усилитель, который не бэклайн (`isAmplifierRubric`).
    { id: "amplification", rubrics: [] },
    // "Venue Mixing and PA" names both, but what a rider files under it is the house desk and its
    // drive — the mixing system is the question it answers.
    { id: "mixing", rubrics: ["Mixing Consoles", "FOH mixing system", "Venue Mixing and PA"] },
    { id: "backline", rubrics: ["Backline"] },
    { id: "monitoring", rubrics: ["Monitoring"] },
    { id: "instruments", rubrics: ["Instruments and access"] },
    { id: "mics", rubrics: ["Microphones and DI"] },
    { id: "stands", rubrics: ["Stands"] },
    { id: "stage", rubrics: ["Stage construction", "Stage Gears"] },
    { id: "power", rubrics: ["Power distribution"] },
    { id: "wire", rubrics: ["Wire"] },
    // Расходники — хвост погрузки: их считают, когда всё остальное уже названо. Батарейки к
    // подтверждённым комплектам радиосистем попадают сюда (владелец, 30.09.2026).
    { id: "consumables", rubrics: ["Consumables"] },
];
const SECTION_BY_RUBRIC = new Map(GEAR_SECTIONS.flatMap((s) => s.rubrics.map((r) => [r, s.id])));
/** The section a line's `Category` belongs to, or `undefined` for a category outside the catalogue
 *  (the corpus carries free text — «Коммутация», «Ударная установка», `""`). Such a category is its
 *  own section, after every known one, under its own spelling; guessing which known section it
 *  "means" would be a silent migration of a user's data. */
export function gearSectionOf(category) {
    return SECTION_BY_RUBRIC.get(category.trim());
}
/**
 * СТОЙКА ИЗ ИНСТРУМЕНТОВ ЧИТАЕТСЯ В STANDS (владелец, 01.10.2026: «все стэнды из инструментов тоже
 * переехали в стенды. Клавишная стойка, гитарные стойки», затем «исправим данные» и «во всех»).
 *
 * Пресеты исправлены на деве; это — для райдеров, сохранённых раньше с «Instruments and access».
 * Меняется только РАЗДЕЛ, в котором строка показана: сама запись `Category` остаётся, по ней посчитан
 * ключ ответа в отправленных офферах (`gearOrderLineKey`). Стойка — когда «stand» стоит в названии
 * САМО, а не в скобках: «Xylophone (on stand)» и «Triangle (own stand or clip)» — инструменты, а
 * «Les Paul Standart» — гитара.
 */
export function displayGearCategory(name, category) {
    if (gearSectionOf(category) !== "instruments")
        return category;
    const outsideBrackets = name.replace(/\([^)]*\)/g, " ");
    return /\bstands?\b/i.test(outsideBrackets) ? "Stands" : category;
}
//# sourceMappingURL=gear-sections.js.map